import type * as React from 'react';
import { del } from '@Domain/Api';
import accountLogoRemoved, {
	type AccountLogoRemovedAction,
} from '@Application/Branding/AccountLogo/Actions/accountLogoRemoved';
import accountLogoRemovalFailed, {
	type AccountLogoRemovalFailedAction,
} from '@Application/Branding/AccountLogo/Actions/accountLogoRemovalFailed';
import type RemoveAccountLogo from '@Application/Branding/AccountLogo/Commands/RemoveAccountLogo';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type Actions = AccountLogoRemovedAction | AccountLogoRemovalFailedAction;

export default (command: RemoveAccountLogo) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(`${parameters.api.host}/api/accounts/${command.accountId}/logo`);

			const action = accountLogoRemoved({ accountId: command.accountId });
			dispatch(action);
			return action;
		} catch (error) {
			const action = accountLogoRemovalFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
